import { createSlice } from "@reduxjs/toolkit";
import { QuickSightTimer } from "../interfaces/quickSightDashboard.interface";

const initialState: QuickSightTimer = {
  sessionStartTime: "",
  totalTime: 0,
  hospital: 0,
  hospitalsystem: 0,
  hospitalbystate: 0,
  legislator: 0,
  clinicalcategories: 0,
  medications: 0,
  statecompare: 0,
  asc: 0,
  glossary: 0,
};

const quickSightTimerSlice = createSlice({
  name: "quicksight-timer",
  initialState,
  reducers: {
    setQuickSightTimers: (state, action) => ({
      ...state,
      sessionStartTime: initialState.sessionStartTime,
      totalTime: action.payload.totalTime,
      hospital: action.payload.hospital,
      hospitalsystem: action.payload.hospitalsystem,
      hospitalbystate: action.payload.hospitalbystate,
      legislator: action.payload.legislator,
      clinicalcategories: action.payload.clinicalcategories,
      medications: action.payload.medications,
      statecompare: action.payload.statecompare,
      asc: action.payload.asc,
      glossary: action.payload.glossary,
    }),
  },
});

export const { setQuickSightTimers } = quickSightTimerSlice.actions;

export default quickSightTimerSlice.reducer;

// Actions
export const setQuickSightTimersAction = (action: QuickSightTimer) => {
  return {
    type: setQuickSightTimers.type,
    payload: action,
  };
};
